<template>
    <div>
        
        <div class="clearfix row py-2 mb-2 mt-2">
            <div class="col-sm-12 float-right text-right">
                <b-button id="show-btn" class="" @click="addReport()">+ Add Report</b-button>                                
            </div>
        </div>
        
        <div class="">
            <b-overlay :show="showoverlay_list" rounded="sm" class="employee-table-wrapper table-sticky-height">
                <div class="ibox-content px-0">
                <table
                    class="employee-list-table table-overflow table-sticky ess-custom-table document-table tax-documents table-list fund_list_table">
                    <thead>
                        <tr class="table-head">
                            <td>Effective Date</td>
                            <td>Proposed Contribution Amount</td>
                            <td>Download Report</td>
                            <td>Actuarial Type</td>
                            <td>Salary Basis</td>                                
                            <td>Actuarial Report Rate</td>
                            <td>Monthly Contribution Rate</td>
                            <td>Effective End Date</td>
                            <td>Actions</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="hover-bg table-row border-bottom mx-2" v-for="(contribution, n) in paginatedData">

                            <td class="col-md-2 align-middle list-columns text-center">{{ contribution.effective_date }}</td>
                            <td class="col-md-2 align-middle list-columns text-right">{{ formatMoney(contribution.amount) }}</td>
                            <td class="col-md-1 align-middle list-columns text-center" id="show_attachments">
                                <a href="javascript:void(0);">
                                    <b-icon icon="download" scale="2" @click.prevent="downloadContribution(contribution.id)"></b-icon>
                                </a>
                            </td>
                            <td class="col-md-3">{{ getActuarialTypeText(contribution.actuarial_type) }}</td>
                            <td class="col-md-2 align-middle list-columns text-left">{{ getSalaryTypeText(contribution.salary_base) }}</td>
                            <td class="col-md-1 text-center"> {{ formatMoney(contribution.report_rate) }} </td>
                            <td class="col-md-1 text-center"> {{ formatMoney(contribution.monthly_rate) }} </td>
                            <td class="col-md-1 text-center"> {{ contribution.effective_end_date }} </td>

                            <td class="clearfix col-md-6 align-middle">
                                <div class="float-right position-relative">
                                    <b-button-toolbar>
                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <b-icon icon="three-dots-vertical"></b-icon>
                                        </a>
                                        <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                            <b-button-group class="mr-0">
                                                <b-button v-if="n==0" variant="outline-secondary" title="Update" @click="monthlyGfView(contribution)"><b-icon icon="pencil" class="mr-2" aria-hidden="true" ></b-icon>Update</b-button>
                                                <b-button v-else variant="outline-secondary" title="View Details" @click="showDetails(contribution)"><b-icon icon="eye" class="mr-2" aria-hidden="true" ></b-icon>Show Details</b-button>
                                                <b-button variant="outline-secondary" title="Delete Report" @click="deleteActuarial(contribution.id)"><b-icon icon="trash" class="mr-2" aria-hidden="true" ></b-icon>Delete</b-button>
                                            </b-button-group>
                                        </div>
                                    </b-button-toolbar>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                <div v-else class="px-3 mt-5">

                    <ul class="pagination b-pagination float-left mb-0 mt-1">
                        <li class="page-item disabled m-2">View</li>
                        <li class="page-item disabled">
                            <b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select>
                        </li>
                        <li class="page-item disabled m-2">per page. Total {{ paginatedData.length }} records found. </li>
                    </ul>

                    <b-pagination-nav v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number></b-pagination-nav>

                </div>                        

            </b-overlay>
        </div>
    
        <div class="col-sm-12  px-0">
            <b-modal id="bv-modal-add-accural-report" size="lg" hide-footer :title="form_title">
                            
                <gf-acturial-form :data="data" :readonly="is_readonly"  @listReturn="listReturn"></gf-acturial-form>
            </b-modal>
        </div>

        
    </div>
</template>

<script>
    export default {
        mounted() { },

        data() {
            return {
                showoverlay: false,                              
               
                showoverlay_list: false,

                // paginatedData: [
                //     {   "id": 1, "effective_date": '2021-01-15' , "proposed_contribution_amount": "236,348.00", 
                //         "actuarial_type": "Actuarial Amount Based Contribution", "salary_basis": "N/A", "actuarial_report_rate": "N/A",
                //          "monthly_contribution_rate": "N/A",
                //         "effective_end_date": "2021-12-31", 
                //     },
                //     {   "id": 1, "effective_date": '2021-01-15' , "proposed_contribution_amount": "236,348.00", 
                //         "actuarial_type": "Actuarial Amount Based Contribution", "salary_basis": "N/A", "actuarial_report_rate": "N/A",
                //          "monthly_contribution_rate": "N/A",
                //         "effective_end_date": "2021-12-31", 
                //     },
                //     {   "id": 1, "effective_date": '2021-01-15' , "proposed_contribution_amount": "236,348.00", 
                //         "actuarial_type": "Actuarial Amount Based Contribution", "salary_basis": "N/A", "actuarial_report_rate": "N/A",
                //          "monthly_contribution_rate": "N/A",
                //         "effective_end_date": "2021-12-31", 
                //     },
                                     
                // ],

                status: [
                    {value: "1", text: "Enabled"},
                    {value: "2", text: "Disabled"},
                ],
                length: 20,
                temp_length: 20,
                totalaccounts: 0,
                length_options:[
                    {value: 20, text: "20"},
                    {value: 50, text: "50"},
                    {value: 100, text: "100"}
                ],
                pagination: {currentPage: 1, pages: 1},
                fdata: {},
                month_list: 
                    [
                        {value: "1", text: "January"},
                        {value: "2", text: "February"},
                        {value: "3", text: "March"},
                        {value: "4", text: "April"},
                        {value: "5", text: "May"},
                        {value: "6", text: "June"},
                        {value: "7", text: "July"},
                        {value: "8", text: "August"},
                        {value: "9", text: "September"},
                        {value: "10", text: "October"},
                        {value: "11", text: "November"},
                        {value: "12", text: "December"},
                        
                    ],



                gf_type: '',

                type_of_run: '',
                data: {},
                acturials:[],
                search: '',
                actuarial_type_list: [
                    {value: "1", text: "Rate Based"},
                    {value: "2", text: "Amount Based"},                                      
                ],

                salary_basis_list: [
                    {value: "1", text: "Basic Salary"},
                    {value: "2", text: "Gross Salary"},                                      
                ],
                form_title: '',
                is_readonly: false,
            } 
        },
        
        methods: {
            listReturn(data) {
                console.log('data');
                console.log(data);
                // if(data == 'form') {
                    this.$bvToast.toast(data.message, {
                        title: `Success`,
                        variant: 'success',
                        solid: true
                    });
                    this.$bvModal.hide('bv-modal-add-accural-report');
                    this.getActurialList();
                // }
            },
            downloadContribution(id) {
                let formData = new FormData();
                formData.append('id', id);
                this.downloadBlobResponse(
                    axios.post(this.$api_url + '/gf/actuarial-document', formData, { responseType: 'blob' }),
                    'loader', // your loader key in this component
                    (data) => {
                        if (data.error) {
                            this.$bvToast.toast(data.error, {
                                title: 'Warning',
                                variant: 'danger',
                                solid: true,
                            });
                        }
                    }
                );
            },

            getStatusText(value) {
                const statusItem = this.status.find((item) => item.value === String(value));
                return statusItem ? statusItem.text : "N/A";
            },                                        
            
            addReport(){
                this.form_title = "Add Actuarial Report";
                this.data = '';
                this.is_readonly = false;
                this.$bvModal.show('bv-modal-add-accural-report');
            },
           
            showDetails(data) {
                this.data = data;
                this.form_title = "Actuarial Report Details";
                this.is_readonly = true;
                this.$bvModal.show('bv-modal-add-accural-report');
            },

            monthlyGfView(data){
                this.type_of_run = data.type_of_run;
                this.data = data;
                this.form_title = "Update Actuarial Report";
                this.is_readonly = false;
                this.$bvModal.show('bv-modal-add-accural-report');
            },
            getActuarialTypeText(value) {
                const type = this.actuarial_type_list.find(item => item.value === String(value));
                return type ? type.text : 'N/A';
            },
            getSalaryTypeText(value) {
                if(value == 0) {
                    return 'N/A';
                } else {
                    const type = this.salary_basis_list.find(item => item.value === String(value));
                    return type ? type.text : 'N/A';
                }
            },

            getActurialList() {
                axios.get(this.$api_url+'/gf/get-acturial-list')
                .then(function(response){
                    this.acturials = response.data;
                }.bind(this));
            },
            deleteActuarial(id) {
                this.$bvModal.msgBoxConfirm('Are you sure you want to delete this Actuarial Report?', {
                    title: 'Confirm Delete',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'primary',
                    okTitle: 'YES',
                    cancelTitle: 'NO',
                    footerClass: 'p-2 d-flex justify-content-end',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {
                        let formData = new FormData();
                        formData.append('id', id);
                        axios.post(this.$api_url + '/gf/delete-acturial', formData)
                            .then(response => {
                                if (response.data.success) {
                                    this.$bvToast.toast(response.data.message, {
                                        title: 'Success',
                                        variant: 'success',
                                        solid: true
                                    });
                                    this.getActurialList();
                                } else {
                                    this.$bvToast.toast(response.data.message, {
                                        title: 'Error',
                                        variant: 'danger',
                                        solid: true
                                    });
                                }
                            })
                            .catch(error => {
                                this.$bvToast.toast('An error occurred while deleting the report.', {
                                    title: 'Error',
                                    variant: 'danger',
                                    solid: true
                                });
                            });
                    }
                });
            }
        },
        created: function () { 
            this.getActurialList();
        },
        computed: {
            filteredData() {
                let filtered_list = this.acturials;

                // if (this.search) {
                //     filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1; }) });
                // }
                // this.totalaccounts = filtered_list.length;

                // let search_by_custom_fields = this.search_by_filter;
                // var search_terms = new Array();
                // Object.keys(search_by_custom_fields).forEach(key => {                  
                    
                //     if(search_by_custom_fields[key] != '' && search_by_custom_fields[key] != null && search_by_custom_fields[key] != 0)
                //     {
                //         search_terms.push(`${key}:${search_by_custom_fields[key]}`);
                //     }
                                    
                // });
                // if(search_terms.length > 0)
                // {                    
                //     for (var i = 0; i < search_terms.length; i++)
                //     {
                //         const term_to_search = search_terms[i].split(":");
                //         let search_key = term_to_search[0];
                //         let search_value =  term_to_search[1];

                //         filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) =>
                //         {                            
                //             return String(row[search_key]).toLowerCase().indexOf(search_value.toLowerCase()) > -1;
                //         })});
                //     }
                //     this.pagination.currentPage = 1;
                // }

                
                return filtered_list;
            },
            paginatedData() {

                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },
            financial_year_list() {
                let startYear = 2020;
                let currentYear = new Date().getFullYear();
                let activeEndYear = new Date().getMonth() >= 6 ? currentYear + 1 : currentYear;
                let list = [];
                for (let y = startYear; y <= activeEndYear; y++) {
                    let val = `${y}-${y + 1}`;
                    list.push({ value: String(y - startYear), text: val });
                }
                return list;
            }
         }
        
    }
    
</script>
